<template>
  <Modal :id="id" :title="title">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <Field
              type="text"
              v-model="nateId"
              value=""
              label="NATE ID"/>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="submit">Save</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "update-nate-id-modal",
      enrollment: null,
      nateId: ''
    };
  },
  computed: {
    title() {
      return !!this.enrollment.nate_id
          ? "Re-assign NATE ID"
          : "Add NATE ID";
    },
  },
  methods: {
    submit() {
      this.axios
          .post(
              this.route("training.courses.update-nate-id", {
                enrollment: this.enrollment.id,
              }),
              { nate_id: this.nateId }
          )
          .then((response) => {
            this.resolve(response.data);
          });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
    this.nateId = this.enrollment.nate_id;
  },
};
</script>